/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Footer from './Footer/index'
import Header from './Header/index'
import React from 'react'
import TasksCreateForm from 'DesignSystem/TasksCreateForm/index'
import TysiaOverlay from 'DesignSystem/TysiaOverlay/index'
import TysiaOverlayContent from 'DesignSystem/TysiaOverlay/TysiaOverlayContent/index'
import TysiaOverlayFooter from 'DesignSystem/TysiaOverlay/TysiaOverlayFooter/index'
import TysiaOverlayHeader from 'DesignSystem/TysiaOverlay/TysiaOverlayHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/NewTaskOverlay/Content",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let tabSelectedNewTaskOverlayFormValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form',
})
let tabSelectedNewTaskOverlayFormChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form',
})
  return (<React.Fragment
>
<TysiaOverlay
  viewPath={`${viewPath}/TysiaOverlay`}
 left="auto"
 right={dtSpaceS}
 width="500px"
>
{childProps => (
<React.Fragment>
<TysiaOverlayHeader
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayHeader`}
>
{childProps => (
<Header
{...childProps}
  viewPath={`${viewPath}/Header`}
/>
)}
</TysiaOverlayHeader>
<TysiaOverlayContent
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayContent`}
>
{childProps => (
<TasksCreateForm
{...childProps}
  viewPath={`${viewPath}/TasksCreateForm`}
 data="tab.selected.new_task_overlay.form"
 value={tabSelectedNewTaskOverlayFormValueData}
 onChange={tabSelectedNewTaskOverlayFormChangeData}
/>
)}
</TysiaOverlayContent>
<TysiaOverlayFooter
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayFooter`}
>
{childProps => (
<Footer
{...childProps}
  viewPath={`${viewPath}/Footer`}
/>
)}
</TysiaOverlayFooter>
</React.Fragment>
)}
</TysiaOverlay>
{children}
</React.Fragment>)
}